export default function ReasonBanner({ listing }) {
    const text = listing.reviewNotes || listing.reason
        || 'Your listing needs changes before it can go live.';

    return (
        <div className="props-reason-banner drawer-reason-banner">
            <div className="props-reason-banner-body">
                <div className="props-reason-banner-title">Reason from Ops</div>
                <div className="props-reason-banner-text">{text}</div>
            </div>
        </div>
    );
}
